import React, { FC, useMemo, useState } from 'react';
import styles from './questionTab.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface Props {
  count: number;
  selectedIndex?: number;
  loading: boolean;

  onItemClicked(index: number): void;
}

export const QuestionTab: FC<Props> = (props) => {
  const { count, selectedIndex, onItemClicked } = props;

  // TODO 컴포넌트 분리 필요
  const questions = [...new Array(count)].map((_, i) => ({
    name: 'Q. ' + (i + 1),
    handler: () => !props.loading && onItemClicked(i),
    statusClsName: i === selectedIndex ? 'selected' : null,
  }));

  // TODO 컴포넌트 분리 필요
  const renderList = () =>
    questions.map(({ name, handler, statusClsName }) => (
      <button className={cx('item', statusClsName)} onClick={handler} key={name}>
        {name}
      </button>
    ));

  return <div className={cx('tabContainer')}>{renderList()}</div>;
};
